import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectAllocations,
  selectAllocationsUpdateStatus,
  selectAllocationsUpdating,
  selectBlends,
  selectBlendSaving,
  selectDefaultAllocations,
  selectFeasibilitySuppliers,
  selectGroupTemplates,
  selectLoadError,
  selectLoading,
  selectRateCards,
  selectSavedBlendId,
  selectSuppliersMetaData,
  selectSuppliersMetaDataBlendId,
  selectSurvey,
} from './manage-supplier.selectors';

@Injectable({ providedIn: 'root' })
export class ManageSupplierSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly survey = this._store.selectSignal(selectSurvey);

  public readonly allocations = this._store.selectSignal(selectAllocations);

  public readonly feasibilitySuppliers = this._store.selectSignal(
    selectFeasibilitySuppliers,
  );

  public readonly blends = this._store.selectSignal(selectBlends);

  public readonly groupTemplates =
    this._store.selectSignal(selectGroupTemplates);

  public readonly defaultAllocations = this._store.selectSignal(
    selectDefaultAllocations,
  );

  public readonly rateCards = this._store.selectSignal(selectRateCards);

  public readonly suppliersMetaData = this._store.selectSignal(
    selectSuppliersMetaData,
  );

  public readonly suppliersMetaDataBlendId = this._store.selectSignal(
    selectSuppliersMetaDataBlendId,
  );

  public readonly loading = this._store.selectSignal(selectLoading);

  public readonly loadError = this._store.selectSignal(selectLoadError);

  public readonly allocationsUpdateStatus = this._store.selectSignal(
    selectAllocationsUpdateStatus,
  );

  public readonly allocationsUpdating = this._store.selectSignal(
    selectAllocationsUpdating,
  );

  public readonly blendSaving = this._store.selectSignal(selectBlendSaving);

  public readonly savedBlendId = this._store.selectSignal(selectSavedBlendId);
}
